import React, { Component } from 'react'

import {
  StyledTextInput,
  StyledInput,
  StyledPlaceholder
} from './TextInput.styles'

export default class TextInput extends Component {
  constructor(props) {
    super(props)

    // value is an instance propertiy, so onChange handlers can conform to HTML standard:
    // <TextInput onChange={ e => e.target.value } />
    this.value = ''
    this.changeEvent = { target: this }

    this.state = {
      value: '',
      isPlaceholderVisible: true
    }
  }

  onChange = event => {
    const value = this.value = event.target.value

    this.setState({ value })
    this.props.onChange(this.changeEvent)
  }

  onFocus = event => {
    if (this.state.value === '') { this.setState({ isPlaceholderVisible: false }) }
  }

  onBlur = event => {
    if (this.state.value === '') { this.setState({ isPlaceholderVisible: true }) }
  }

  static getDerivedStateFromProps(props, state) {
    const value = (props.value !== state.value) ? props.value : state.value

    return {
      value,
      isPlaceholderVisible: (value === '')
    }
  }

  render() {
    return (
      <StyledTextInput visible={this.props.visible}>
        <StyledPlaceholder visible={this.state.isPlaceholderVisible}>
          { this.props.placeholder }
        </StyledPlaceholder>
        <StyledInput type='text' value={this.state.value} onChange={this.onChange} onFocus={this.onFocus} onBlur={this.onBlur} tabIndex={this.props.tabIndex} />
      </StyledTextInput>
    )
  }
}
